import React from 'react';
import { getCardImageSrc, handleCardImageError } from '../hooks/useCardImage';
import { getCardRarityClass } from '../utils/cardUtils';
import GLOBALS from '../config/globals';

const SPECIAL_GAME_META = {
    [GLOBALS.SPECIAL_GAME_TYPES.RADIOACTIVE]: { verb: 'irradiated', cssClass: 'variation-radioactive' },
    [GLOBALS.SPECIAL_GAME_TYPES.CORRUPTED]: { verb: 'corrupted', cssClass: 'variation-corrupted' },
};

const SpecialGameReward = ({ specialGame }) => {
    if (!specialGame) return null;

    const meta = SPECIAL_GAME_META[specialGame.variationName?.toLowerCase()];
    if (!meta) return null;

    return (
        <div className={`postgame-reward-item postgame-special-game-item ${meta.cssClass}`}>
            <div className={`postgame-reward-img-wrapper postgame-reward-card-wrapper ${meta.cssClass}`}>
                <img
                    src={getCardImageSrc(specialGame.cardSeriesKey)}
                    alt={specialGame.playerName}
                    className="postgame-reward-card-img"
                    onError={handleCardImageError}
                />
                <span className={`postgame-reward-card-rating ${getCardRarityClass(specialGame.rating)}`}>
                    {specialGame.rating}
                </span>
            </div>
            <div className="postgame-reward-label">{specialGame.playerName} was {meta.verb}!</div>
        </div>
    );
};

export default SpecialGameReward;
